import Api from '../api'

export default ({

  state: {
    billSundaryLists: [],
    extraSalesExpenses: [],
    extraPurchaseExpenses: []
  },
  mutations: {
    ADD_BILL_SUNDRY (state, billSundaryLists) {
      let billSundaryList = state.billSundaryLists.concat(billSundaryLists)
    //   console.log(itemgroup)
      state.billSundaryLists = billSundaryList
    //   console.log(state.itemgroups)
    },
    SET_BILL_SUNDRY (state, billSundaryList) {
      state.billSundaryLists = billSundaryList
    },
    SET_BILL_SALES_SUNDRY (state, billSundaryList) {
      state.billSundaryLists = billSundaryList
    },
    UPDATE_PURCHASE_SUNDARY(state, updateBillSundry) {
      state.billSundaryLists = state.billSundaryLists.map(billSundary => billSundary.id !== updateBillSundry.id ? billSundary : {...billSundary, ...updateBillSundry})
    },
    DELETE_PURCHASE_SUNDARY (state, purSundary) {
      let purchaseSundary = state.billSundaryLists.filter(a => a.id !== purSundary.id)
      state.billSundaryLists = purchaseSundary
    },
    EXTRA_SALES_EXPENSES(state, salesExpenses) {
      state.extraSalesExpenses = salesExpenses
    },
    EXTRA_PURCHASE_EXPENSES(state, purchaseExpenses) {
      state.extraPurchaseExpenses = purchaseExpenses
    }
  },
  actions: {
    async createPurchaseBillSundary({commit}, purchaseBillSundry) {
      let response = await Api.request('post', '/billSundry/' + this.state.organisationid + '/' + this.state.user.id + '/purchase', purchaseBillSundry)
      let savedPurchaseBillSundry = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_BILL_SUNDRY', savedPurchaseBillSundry)
      }
      return response
    },
    async createSalesBillSundary({commit}, salesBillSundry) {
      let response = await Api.request('post', '/billSundry/' + this.state.organisationid + '/' + this.state.user.id + '/sales', salesBillSundry)
      let savedSalesBillSundry = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_BILL_SUNDRY', savedSalesBillSundry)
      }
      return response
    },
    async loadPurchaseBillSundry({commit}) {
      let response = await Api.request('get', '/billSundry/' + this.state.organisationid + '/purchase', null)
      commit('SET_BILL_SUNDRY', response.data.data)
      return response
    },
    async loadSalesBillSundry({commit}) {
      let response = await Api.request('get', '/billSundry/' + this.state.organisationid + '/sales', null)
      commit('SET_BILL_SALES_SUNDRY', response.data.data)
      return response
    },
    async deletePurchaseSundary({commit}, deleteRea) {
      let response = await Api.request('delete', '/billSundry/' + deleteRea.inventoryExpensesId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let purchaseSundary = response.data.data
      commit('DELETE_PURCHASE_SUNDARY', purchaseSundary)
      return response
    },
    async updatePurchaseSundary({commit}, billSundary) {
      let resp = await Api.request('put', '/billSundry/' + billSundary.id, billSundary)
      commit('UPDATE_PURCHASE_SUNDARY', resp.data.data)
      return resp
    },
    async extraSalesExpenses({commit}) {
      let resp = await Api.request('get', '/billSundry/' + this.getters.organisationId + '/sales')
      commit('EXTRA_SALES_EXPENSES', resp.data.data)
      return resp
    },
    async extraPurchaseExpenses({commit}) {
      let resp = await Api.request('get', '/billSundry/' + this.getters.organisationId + '/purchase')
      commit('EXTRA_PURCHASE_EXPENSES', resp.data.data)
      return resp
    }
  },
  getters: {

  }
})



// WEBPACK FOOTER //
// ./src/store/billSundary.js